import Table from './components/Table';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'table',
  pluginComponent: Table,
});
